/** 查新报告阅读完成后的分享与导出操作引导 service。 */
export interface NoveltySearchReportValueOnboardingService {
    /** 订阅报告生成完成事件并启用当前页面的阅读进度监听。重复调用不会重复订阅。 */
    initialize(): void;
    /** 消费一次当前报告操作引导归因；仅在引导仍激活时返回 true。 */
    consumeActionGuide(): boolean;
    /** 仅在本地开发环境绕过受众判断，强制启动指定报告的操作引导监听。 */
    debugStart(taskId: string): void;
    /** 销毁事件订阅、Driver、按钮引导与定时任务。 */
    destroy(): void;
}

/** 查新报告操作引导 service 的容器标识。 */
export const NoveltySearchReportValueOnboardingService = Symbol('NoveltySearchReportValueOnboardingService');
